export const SIDEBAR_WIDTH_EXPANDED = 254;
export const SIDEBAR_WIDTH_COLLAPSED = 72;
